"use client";

import dynamic from "next/dynamic";

const GettingStartedCarousel = dynamic(() => import("./GettingStartedCarousel"), {
  loading: () => <div className="h-20 bg-gray-100 animate-pulse rounded" />,
});

export default GettingStartedCarousel;

